import dynamic from 'next/dynamic'

export const DynamicConfirmationModal = dynamic(
  () => import('.').then((mod) => mod.ConfirmationModal),
  { ssr: false },
)
